export const WebTypesData = [
  {
    icon:"tdesign:map-edit",
    title:'WEB DESIGN',
    titleAR:'تصميم المواقع',
    disc:"We create visually stunning, user-friendly designs that reflect your brand identity and deliver seamless experiences across all devices.",
    discAR:"بتكر تصاميم جذابة بصرياً وسهلة الاستخدام تعكس هوية علامتك التجارية، وتوفر تجربة سلسة على جميع الأجهزة.",
    link:'/web-design-page'
  },
  {
    icon:"carbon:development" ,
    title:'WEB DEVELOPMENT',
    titleAR:'تطوير المواقع',
    disc:"We build fast, secure, and scalable websites and platforms, turning creative designs into powerful digital solutions that grow with your business.",
    discAR:"و نقوم ببناء مواقع ومنصات سريعة، آمنة، وقابلة للتوسع، نحول من خلالها التصاميم الإبداعية إلى حلول رقمية قوية تنمو مع عملك.",
    link:'/web-dev-page'
  },

]